module.exports = __webpack_public_path__ + "static/media/ms.830476bc.svg";